import React from 'react';

interface StatCardProps {
  label: string;
  value: React.ReactNode;
  /** Short glyph/letter or small node shown in the gradient badge. */
  icon?: React.ReactNode;
  /** Muted secondary line under the value (e.g. a formula or sub-count). */
  hint?: React.ReactNode;
  /** Tailwind background classes for the icon badge. Defaults to primary gradient. */
  accentClass?: string;
  className?: string;
}

export function StatCard({
  label,
  value,
  icon,
  hint,
  accentClass = 'bg-gradient-primary',
  className = '',
}: StatCardProps) {
  return (
    <div
      className={`rounded-2xl border border-gray-100 bg-white p-5 shadow-card dark:border-gray-700/60 dark:bg-gray-800 dark:shadow-card-dark ${className}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[0.7rem] font-bold uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {label}
          </p>
          <p className="mt-1.5 truncate text-2xl font-bold text-gray-900 dark:text-gray-100">
            {value}
          </p>
          {hint != null && <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">{hint}</p>}
        </div>
        {icon != null && (
          <span
            className={`flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl text-base font-bold text-white shadow-raised ${accentClass}`}
          >
            {icon}
          </span>
        )}
      </div>
    </div>
  );
}
